import jobListingService from '@/services/JobListingService';
import type { JobListing } from '@/types/JobListing';
import type { PaginatedListMeta } from '@/types/PaginatedListMeta';
import { API_LIST_META } from '@/utils/fixtures/ApiListMeta';

export default function useJobListing() {
  const fetching = ref(false);
  const jobListing = ref<JobListing | null>(null);
  const jobListings = ref<JobListing[]>([]);
  const jobListingsMeta = ref<PaginatedListMeta>(API_LIST_META);

  const getJobListings = async (page = 1, limit = 10, recommended = false): Promise<JobListing[]> => {
    if (fetching.value) return [];

    jobListings.value = [];
    fetching.value = true;
    jobListingsMeta.value = API_LIST_META;

    const payload = {
      page: page,
      per_page: limit,
      sort: '-created_at',
      includes: ['author'],
    };

    const { data } = recommended
      ? await jobListingService.getRecommendedJobListings(payload)
      : await jobListingService.getJobListings(payload);

    if (data.value) {
      jobListings.value = data.value.data || [];
      jobListingsMeta.value = data.value.meta || API_LIST_META;
    }
    fetching.value = false;

    return jobListings.value;
  };

  const findJobListing = async (id: number): Promise<JobListing | null> => {
    if (fetching.value) return null;

    jobListing.value = null;
    fetching.value = true;

    const { data } = await jobListingService.getJobDetails(id);

    fetching.value = false;
    jobListing.value = data.value || null;

    return jobListing.value;
  };

  const getMyJobs = async (page = 1, limit = 10, is_draft?: boolean): Promise<JobListing[]> => {
    if (fetching.value) return [];

    jobListings.value = [];
    fetching.value = true;
    jobListingsMeta.value = API_LIST_META;

    const payload = {
      page: page,
      per_page: limit,
      sort: '-created_at',
      includes: ['author'],
      is_draft: is_draft,
    };

    const { data } = await jobListingService.getMyJobs(payload);

    if (data.value) {
      jobListings.value = data.value.data || [];
      jobListingsMeta.value = data.value.meta || API_LIST_META;
    }
    fetching.value = false;

    return jobListings.value;
  };

  return {
    fetching,

    jobListing,
    jobListings,
    jobListingsMeta,

    getJobListings,
    findJobListing,
    getMyJobs,
  };
}
